import React, { Component } from "react";
import { documentObjectIconMap } from "Common/dictionaries/documentObjectIconId";
class IconItemComponent extends Component {
    render() {
        const { value } = this.props;
        if (value) {
            return (React.createElement("div", { className: "flex-single-row with-gap-5" },
                React.createElement("img", { src: documentObjectIconMap[value], alt: value }),
                React.createElement("span", { className: "flex-fill-block text-overflow-ellipsis" }, value)));
        }
        return null;
    }
}
export default IconItemComponent;
